import { render, staticRenderFns } from "./chat-add-or-update.vue?vue&type=template&id=7e9977ab&scoped=true"
import script from "./chat-add-or-update.vue?vue&type=script&lang=js"
export * from "./chat-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./chat-add-or-update.vue?vue&type=style&index=0&id=7e9977ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9977ab",
  null
  
)

export default component.exports